<div class="hd-channels-overview">
  <h2 class="hd-channels-overview__title">{{ title() }}</h2>
  <p class="hd-channels-overview__intro">{{ intro() }}</p>

  @for (group of groups(); track group.key) {
    <section class="hd-channels-overview__group" [attr.data-type]="group.key">
      <h3 class="hd-channels-overview__group-title">{{ group.title }}</h3>
      <p class="hd-channels-overview__group-hint">{{ group.hint }}</p>

      @for (channel of group.channels; track channel.key) {
        <!-- Gewone .md-href: de doc-viewer-delegatie navigeert in hetzelfde paneel. -->
        <a class="hd-channels-overview__row" href="{{ channel.key }}.md">
          <span class="hd-channels-overview__row-key">{{ channel.key }}</span>
          <span class="hd-channels-overview__row-text">
            <span class="hd-channels-overview__row-name">
              {{ channel.name }}
              @for (badge of channel.badges; track badge) {
                <span class="hd-channels-overview__row-badge">{{ badge }}</span>
              }
            </span>
            @if (channel.shortDescription) {
              <span class="hd-channels-overview__row-description">{{ channel.shortDescription }}</span>
            }
          </span>
          <i class="fas fa-chevron-right hd-channels-overview__row-chevron" aria-hidden="true"></i>
        </a>
      }
    </section>
  }
</div>
